var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.769,
    height: 22,
    fill: "none",
    viewBox: "0 0 17.769 22"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M16.258 19.249c-.909 1.364-1.873 2.695-3.34 2.717-1.468.032-1.939-.87-3.603-.87-1.676 0-2.19.848-3.581.902-1.435.055-2.52-1.451-3.439-2.782C.422 16.499-1.012 11.494.915 8.128c.953-1.671 2.661-2.727 4.512-2.76 1.402-.022 2.738.957 3.603.957.854 0 2.475-1.177 4.173-1.001.711.033 2.705.286 3.986 2.178-.099.066-2.377 1.407-2.355 4.19.033 3.322 2.902 4.433 2.935 4.444-.033.077-.46 1.584-1.511 3.113m-6.253-17.6c.8-.912 2.124-1.605 3.22-1.649.142 1.287-.373 2.585-1.14 3.509-.755.935-2.004 1.66-3.23 1.562-.164-1.265.449-2.585 1.15-3.421"
  })));
};
export default SvgApple;